import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class FaqCategoryForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="category"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] && <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="items"
                            columns={{
                                "question": {header: "Kérdés", width: 11, sortable: true, filterable: true}
                            }}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="GYIK"
                        />
                    </div>
                </div>}
            </form>
        );
    }
}

export default createForm(FaqCategoryForm);
